
import toShort from '../../../../../services/utils/dateParser';
import { aircraftPics } from '../../../../../config/staticConfigs';


import css from './CDGeneral.module.css'
import { useNavigate } from 'react-router-dom';

function CDGeneral ({data, toggleModal}) {

    const navigate = useNavigate();

    const logo = aircraftPics;


    return (
        <div className={css.general}>
                <h2 className={css.h2}>General</h2>
                <div className={css.details}>
                    <div
                        className={css.image}
                        style={{
                            backgroundImage: `${logo[data.courseAircraftTypeId]}`,
                        }}
                    ></div>
                    <div>
                        <p>
                            Course Start: <strong>{toShort(data.courseStart)}</strong>
                        </p>
                        <p>
                            Course End: <strong>{toShort(data.courseEnd)}</strong>
                        </p>
                        <p>
                            Location: <strong>{data.courseLocation}</strong>
                        </p>
                        <p>
                            Status: <strong>{data.courseStatusName}</strong>
                        </p>
                        <button className={css.editButon} onClick={() => toggleModal()}>
                            Edit
                        </button>
                        <button className={css.viewButton} onClick={() => navigate(`/enroll/${data.courseId}`)}>
                            Enroll
                        </button>
                    </div>
                    <div>
                        <p>
                            Program Id: <strong>{data.courseProgramNo}</strong>
                        </p>
                        <p>
                            Course Duration: <strong>{data.courseDuration} days</strong>
                        </p>
                        <p className={css.comments} style={{fontSize: '1rem'}}>
                            <strong>Comments:</strong><br />{data.courseComments}
                        </p>
                    </div>
                </div>
            </div>
    )
}

export default CDGeneral